type GaEvent =
  | "book_now_click"
  | "salon_select"
  | "call_click"
  | "directions_click"
  | "barber_booking_click"
  | "offer_click"
  | "dropin_click"
  | "service_booking_click"
  | "book_again_impression"
  | "book_again_click"
  | "book_again_dismiss";

interface GaParams {
  salon_name?: string;
  service_name?: string;
  barber_name?: string;
  page_url?: string;
  cta_location?: string;
  language?: "sv" | "en";
  device_type?: "mobile" | "desktop";
  shape?: string;
}

declare global {
  interface Window {
    gtag?: (cmd: "event", name: string, params: Record<string, unknown>) => void;
    dataLayer?: unknown[];
  }
}

export function track(event: GaEvent, params: GaParams = {}) {
  if (typeof window === "undefined") return;
  const enriched: GaParams = {
    page_url: typeof location !== "undefined" ? location.pathname : undefined,
    language: typeof location !== "undefined" && location.pathname.startsWith("/en") ? "en" : "sv",
    device_type: typeof window !== "undefined" && window.matchMedia?.("(max-width: 768px)").matches ? "mobile" : "desktop",
    ...params,
  };
  window.gtag?.("event", event, enriched as Record<string, unknown>);
  window.dataLayer?.push({ event, ...enriched });
}
